import apiurl from './apiurl';
const axios = require('axios');

const getRangoFolios= async (params,idToken) =>{
    // console.log(params,idToken);
    
    return new Promise(async (resolve,reject) => {
        try {
            const response = await axios({
                'method':'GET',
                'url':apiurl +'consultahistorialfolios',
                'headers': {
                    'content-type':'application/json',
                    'Authorization':"Bearer "+idToken
                },
                'crossdomain': true,
                'params': {
                    ...params
                }
            })
            resolve(response)
        } catch (error) {
            reject(error);
        }

    })
    
}
export default getRangoFolios;